<template>
  <section :class="$style.section">
    <header v-if="$slots.title" :class="$style.header">
      <p :class="required ? $style.required : ''"><slot name="title" /></p>
      <div v-if="$slots.note" :class="$style.note">
        <slot name="note" />
      </div>
    </header>
    <div :class="$style.content">
      <slot name="content" />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  required?: boolean;
}>();
</script>

<style module lang="scss">
.section {
  p {
    margin-top: 0;
  }

  .header {
    font-size: 16px;
    font-weight: bold;

    @media (--pc) {
      max-width: 252px;
      padding-right: 12px;
    }

    .required::after {
      background-color: #d9d9d9;
      border-radius: 4px;
      content: '必須';
      display: inline-block;
      font-size: 11px;
      font-weight: normal;
      line-height: 1;
      margin: 0 2px 0 10px;
      padding: 2px 6px;
    }

    .note {
      color: #969696;
      font-size: 12px;
      font-weight: normal;
      margin: 3px 0;
      width: 100%;

      a {
        color: var(--color-gray600);
      }
    }
  }

  .content {
    flex-grow: 1;
  }
}
</style>
